<template>
  <m-products-wrapper :dirty-router-after-page-change="false" :product-brands="productBrands"
                      :product-categories="productCategories">
    <div class="related-product-300" slot-scope="{products,pagination,changePageFunction}">
      <b-col cols="12" class="my-4  border-bottom" v-for="product in products"
             v-if="ignoreProduct.indexOf(product.id) === -1" :key="product.id">

        <m-c300>
          <template #pr-1>
            <m-a :href="{name:'Product',params:{name:product.raw_link}}">
              <img class="col-lg-12 card-image" :src="product.thumbnail" :alt="product.name">
            </m-a>
          </template>

          <template #p-1>
            <m-a class="product-name" :href="{name:'Product',params:{name:product.raw_link}}">
              <h3>{{ product.name }}</h3>
            </m-a>
          </template>

          <template #pl-1>
            <div v-if="relatedProductPrice">
              <m-product-price-100 :product="product"/>
              <m-shopping-cart-controller-1 :product="product"/>
            </div>
          </template>
        </m-c300>

      </b-col>

      <m-pagination-400 :meta="pagination" :on-change-page="changePageFunction"/>

    </div>
  </m-products-wrapper>
</template>

<script>

export default {
  name: "RelatedProducts300",
  props: {
    productBrands: {
      default: null
    },
    productCategories: {
      default: null
    },
    ignoreProduct: {
      default: () => {
        return []
      }
    },
    relatedProductPrice: {
      default: true
    },
  }
}
</script>

<style scoped>
.related-product-300 .card-image {
  object-fit: cover;
}

.related-product-300 .product-name, .related-product-300 .product-name:hover {
  color: var(--dark);
}
</style>